<h1 mat-dialog-title>
  Can't delete primary CV
  <button
    (click)="cancelDialog()"
    class="close-btn"
    data-test-id="consultant-cv-primary-dialog-close-button"
    isIconButton="true"
    mat-button
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</h1>
<div class="flex flex-col" mat-dialog-content>
  <p>
    Primary CV cannot be deleted. To delete this CV,
    @if (cvsCount > 1) {
      <span>mark another CV as primary.</span>
    }
    @if (cvsCount === 1) {
      <span>contact 7N IT support.</span>
    }
  </p>
</div>
<mat-dialog-actions align="start">
  <button
    [ngClass]="{ 'small-button': (mediaQueryService.breakpoints$ | async).ltMd }"
    (click)="cancelDialog()"
    color="primary"
    data-test-id="consultant-cv-primary-dialog-ok-button"
    mat-stroked-button
    type="button"
  >
    OK
  </button>
</mat-dialog-actions>
